module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/kind_icons/all_red-0a899d337fe0a148f10c691536a635f2.svg";